import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import SwitchBusinessPage from './SwitchBusinessPage';
import {
  saveSwitchBusinessForm,
  saveOldAccountDetailsForm,
  saveSwitchDateForm,
  oldSignatoriesSelector
} from '../../infrastructure/oldSignatories';
import { SWITCH_BUSINESS_INFO, ROUTE_APPLICATION_COMPLETE_PAGE } from '../../utils/constants';

class SwitchBusinessSection extends Component {
  constructor(props) {
    super(props);
    this.goToNextPage = this.goToNextPage.bind(this);
  }

  goToNextPage(data) {
    if (data.switchOption === 'No') {
      this.props.history.push(ROUTE_APPLICATION_COMPLETE_PAGE);
    } else this.props.saveSwitchBusinessForm(data);
  }

  render() {
    const { bankId, brandId, getBusinessData, offer } = this.props;

    return (
      <SwitchBusinessPage
        brandId={brandId}
        bankId={bankId}
        offer={offer}
        saveSwitchBusinessForm={this.goToNextPage}
        getBusinessData={getBusinessData}
      />
    );
  }
}

SwitchBusinessSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveSwitchBusinessForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveSwitchBusinessForm,
  saveOldAccountDetailsForm,
  saveSwitchDateForm
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  getBusinessData: oldSignatoriesSelector.getBusinessData(state, SWITCH_BUSINESS_INFO)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SwitchBusinessSection);
